(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[609],{

/***/ 39097:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tienda/bono-regalo-experience-box/[slug]",
      function () {
        return __webpack_require__(51320);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4351);
/* harmony import */ var ab_modal_upselling__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91387);
/* harmony import */ var _components_DynamicContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44517);








// import { getLinkFromTranslation, getLocaleFromContext } from "ab-functions";

var ExperienceBoxDetail = function(param) {
    var _content = param.content, content = _content === void 0 ? [] : _content, category = param.category, product = param.product, products = param.products, moduloCross = param.moduloCross;
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common").i18n;
    // console.log("ExperienceBoxDetail category", category);
    // console.log("ExperienceBoxDetail product", product);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showUpsellingModal = ref1[0], setShowUpsellingModal = ref1[1];
    var handleSticky = function() {
        if (window.pageYOffset > window.innerHeight - 90) {
            var ref;
            (ref = document.getElementById("ab-historia-menu")) === null || ref === void 0 ? void 0 : ref.classList.add("sticky");
            setIsSticky(true);
        } else {
            var ref1;
            (ref1 = document.getElementById("ab-historia-menu")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("sticky");
            setIsSticky(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", handleSticky);
        if (window.pageYOffset > window.innerHeight - 90) {
            var ref;
            (ref = document.getElementById("ab-historia-menu")) === null || ref === void 0 ? void 0 : ref.classList.add("sticky");
            setIsSticky(true);
        } else {
            var ref1;
            (ref1 = document.getElementById("ab-historia-menu")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("sticky");
            setIsSticky(false);
        }
        return function() {
            window.removeEventListener("scroll", handleSticky);
        };
    }, []);
    if (content.length > 0 && (product === null || product === void 0 ? void 0 : product.configuradorEbox)) {
        var ref2, ref3;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                content === null || content === void 0 ? void 0 : content.map(function(itm, index) {
                    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_components_DynamicContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, itm), {
                        category: category,
                        product: product,
                        products: products,
                        moduloCross: moduloCross,
                        key: "".concat(itm.fieldGroupName, "-").concat(index),
                        setShowUpsellingModal: setShowUpsellingModal,
                        i18n: i18n
                    }));
                }),
                (product === null || product === void 0 ? void 0 : (ref2 = product.configuradorEbox) === null || ref2 === void 0 ? void 0 : ref2.upselling) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_modal_upselling__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    products: (product === null || product === void 0 ? void 0 : (ref3 = product.configuradorEbox) === null || ref3 === void 0 ? void 0 : ref3.experiencias) || products,
                    product: product,
                    setShowModal: setShowUpsellingModal,
                    showModal: showUpsellingModal,
                    i18n: i18n
                }) : null
            ]
        });
    }
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ExperienceBoxDetail);


/***/ }),

/***/ 81402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ook_loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27336);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73969);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__);






var FormButton = function(_param) {
    var loading = _param.loading, children = _param.children, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "loading",
        "children",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "ab-form-button",
        type: "submit",
        onClick: onClick,
        disabled: loading || disabled
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ook_loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            loading: true,
            mini: true
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormButton);


/***/ }),

/***/ 91387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _Users_javier_villoslada_Proyectos_abadia_retuerta_storefront_abadia_retuerta_wp_connected_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_javier_villoslada_Proyectos_abadia_retuerta_storefront_abadia_retuerta_wp_connected_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_javier_villoslada_Proyectos_abadia_retuerta_storefront_abadia_retuerta_wp_connected_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94960);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(577);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62062);
/* harmony import */ var ab_select_e_box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24053);
/* harmony import */ var ab_form_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81402);
/* harmony import */ var ab_functions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5134);
/* harmony import */ var ab_context_ebox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13757);
/* harmony import */ var ab_context_cart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29359);
/* harmony import */ var _ab_modal_upselling_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92039);
/* harmony import */ var _ab_modal_upselling_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_ab_modal_upselling_scss__WEBPACK_IMPORTED_MODULE_11__);















var ModalUpselling = function(param) {
    var showModal = param.showModal, setShowModal = param.setShowModal, products = param.products, product = param.product, i18n = param.i18n;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,ab_context_ebox__WEBPACK_IMPORTED_MODULE_9__/* .useEboxContext */ .OI)(), 2), stateEbox = ref2[0], dispatchEbox = ref2[1];
    var itemsEbox = stateEbox.itemsEbox, giftMsg = stateEbox.giftMsg, giftName = stateEbox.giftName, giftLastName = stateEbox.giftLastName;
    var addItemsToEbox = dispatchEbox.addItemsToEbox, resetEbox = dispatchEbox.resetEbox;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,ab_context_cart__WEBPACK_IMPORTED_MODULE_10__/* .useCartContext */ .iQ)(), 2), state = ref3[0], dispatch = ref3[1];
    var addItemToCart = dispatch.addItemToCart;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,ab_functions__WEBPACK_IMPORTED_MODULE_8__/* .registerLocale */ .I2)();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "initial";
        }
        (0,ab_functions__WEBPACK_IMPORTED_MODULE_8__/* .registerLocale */ .I2)();
    }, [
        showModal
    ]);
    var tempPrice = 0;
    var tempPriceToShow = numeral__WEBPACK_IMPORTED_MODULE_3___default()(0).value();
    // console.log("estuchePrice", tempPriceToShow);
    itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.map(function(itm) {
        tempPrice += numeral__WEBPACK_IMPORTED_MODULE_3___default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
        tempPriceToShow += numeral__WEBPACK_IMPORTED_MODULE_3___default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
    });
    ;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "modal-upselling-background ".concat(showModal ? "show" : "")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "modal-upselling ".concat(showModal ? "show" : ""),
                id: "modal-container",
                onClick: function(e) {
                    setShowModal(false);
                    document.body.style.overflow = "initial";
                },
                role: "button",
                tabIndex: "0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "content",
                    onClick: function(e) {
                        // console.log("ModalContent onclick");
                        e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: "close",
                            onClick: function(e) {
                                setShowModal(false);
                                document.body.style.overflow = "initial";
                                e.stopPropagation();
                            },
                            children: "+"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ab_select_e_box__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            title: (product === null || product === void 0 ? void 0 : product.name) || "Experience Box ",
                            contenidodebajo: product === null || product === void 0 ? void 0 : product.description,
                            subtitle: t("que-incluye-ebox"),
                            tipo: "Experiencias",
                            products: products,
                            classname: "white upselling",
                            upsellingModal: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ab_form_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            loading: loading,
                            disabled: (0,lodash_es__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(itemsEbox, function(ebox) {
                                return !(ebox === null || ebox === void 0 ? void 0 : ebox.sku);
                            }) || !(itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.length),
                            onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_Users_javier_villoslada_Proyectos_abadia_retuerta_storefront_abadia_retuerta_wp_connected_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                                var addons, extraData;
                                return _Users_javier_villoslada_Proyectos_abadia_retuerta_storefront_abadia_retuerta_wp_connected_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            addons = [];
                                            setLoading(true);
                                            addons.push({
                                                display: "".concat(numeral__WEBPACK_IMPORTED_MODULE_3___default()(tempPrice).format("1,000.00"), "&euro;"),
                                                name: "Ebox - Price",
                                                price: tempPrice,
                                                value: tempPrice
                                            });
                                            if (giftMsg) {
                                                addons.push({
                                                    name: "Dedicatoria Experience Box",
                                                    price: "0",
                                                    value: giftMsg
                                                });
                                            }
                                            if (giftName && giftLastName) {
                                                addons.push({
                                                    name: "Beneficiario",
                                                    price: "0",
                                                    value: giftName + " " + giftLastName
                                                });
                                            }
                                            addons.push({
                                                name: "Experiencias",
                                                price: "",
                                                value: itemsEbox.map(function(itm) {
                                                    return itm.sku;
                                                }).join()
                                            });
                                            addons.push({
                                                name: "Que incluye",
                                                price: "",
                                                value: itemsEbox.map(function(itm) {
                                                    return itm === null || itm === void 0 ? void 0 : itm.name;
                                                }).join()
                                            });
                                            extraData = {
                                                addons: addons
                                            };
                                            _ctx.next = 10;
                                            return addItemToCart({
                                                databaseId: product === null || product === void 0 ? void 0 : product.databaseId,
                                                price: tempPriceToShow
                                            }, 1, null, JSON.stringify(extraData));
                                        case 10:
                                            router.push(t("/cesta"));
                                            setTimeout(function() {
                                                setShowModal(false);
                                            }, 1500);
                                            resetEbox();
                                            document.body.style.overflow = "initial";
                                        case 14:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: t("continue")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "footer",
                            children: t("notaInfoFecha")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalUpselling);


/***/ }),

/***/ 73969:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92039:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [936,4517,4053,9774,2888,179], function() { return __webpack_exec__(39097); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);